
import useSession from "hooks/useSession";
import { useEffect,useState } from "react";
import { ResumeRouteMono } from "../ResumeRouteMono/ResumeRouteMono";
import { ResumeRouteMulti } from "../ResumeRouteMulti/ResumeRouteMulti";
import { setTypeCit } from "services/user/user.session.service";

/**
 * Pagina padre del resumen, desde aqui mostramos la pantalla si es mono o multi el pago
 * @returns 
 */
export const ResumeRoute = () => {
  const { tripSelectedDetails, tripReturnSelectedDetails } = useSession();
  const [pageType, setPageType] = useState('');
  
  useEffect(() => {
    setPageType(isMonoOrMulti())
  }, []);



/**
 * Miramos si en los viajes de ida y vuelta tenemos mas de un PST si es mas de 1 es multi, tambien hay que mirar los viajes
 * informativos, si tenemos un viaje ida y vuelta y en uno de ellos es mas de 1 viaje entonces es multi
 * @returns que tipo de resumen vamos a mostrar mono pago o multi pago
 */

  const isMonoOrMulti = () => {
    let outwardJourneyType='mono'
    let returnJourney='mono';
    let result = 'mono';
    let getPstIda=[] as any;
    let getPstVuelta=[] as any;;
    let isRoundTrip=false//si es tarifa ida/vuelta
    if(tripSelectedDetails?.body?.outwardJourney?.selectedTariff.length!==0){
       getPstIda=tripSelectedDetails?.body?.outwardJourney?.selectedTariff.filter((element) => element )
       let getAve=tripSelectedDetails?.body?.outwardJourney?.selectedTariff.filter((element) => element.provider==="renfe-ave" ) as any
  
       if(getAve[0]?.notes?.filter((item:any) => item?.type === 'ROUND_TRIP_TARIFF')){
        isRoundTrip=true
       }
       
    }

    if(tripReturnSelectedDetails?.body?.returnJourney?.selectedTariff.length!==0){
      getPstVuelta=tripReturnSelectedDetails?.body?.returnJourney?.selectedTariff.filter((element) => element )
   }


   if (getPstIda?.length > 1) {
   if(validarArrayRenfe(getPstIda)===true){
   outwardJourneyType = "mono";
   }else{
    outwardJourneyType = "multi";
   }

  } else if (tripSelectedDetails?.body?.outwardJourney?.selectedTariff.length!==0) {
    outwardJourneyType = "mono";
  }
  if (getPstVuelta?.length > 1) {
     if(validarArrayRenfe(getPstVuelta)===true){
   returnJourney = "mono";
   }else{
    returnJourney = "multi";
   }
 
  } else if (tripReturnSelectedDetails?.body?.returnJourney?.selectedTariff.length!==0 && tripReturnSelectedDetails?.body?.returnJourney?.selectedTariff!==undefined) {
    returnJourney = "mono";
  }

  if(getPstIda?.length >= 1 && getPstVuelta?.length >= 1 && (tripSelectedDetails?.body?.outwardJourney?.selectedTariff ||tripReturnSelectedDetails?.body?.returnJourney?.selectedTariff )){
    const hasProviderRenfeAveIda = getPstIda.some((item:any) => item.provider === "renfe-ave");
    const hasProviderRenfeAveVuelta = getPstVuelta.some((item:any) => item.provider === "renfe-ave");
    if (hasProviderRenfeAveIda && hasProviderRenfeAveVuelta) {
      const noHasProviderRenfeAveIda = getPstIda.some((item:any) => item.provider !== "renfe-ave");
      const noHasProviderRenfeAveVuelta = getPstVuelta.some((item:any) => item.provider !== "renfe-ave");
      if(noHasProviderRenfeAveIda && noHasProviderRenfeAveVuelta){
        returnJourney = "multi";
        outwardJourneyType = "multi";
      }else{
        returnJourney = "mono";
        outwardJourneyType = "mono";
      }

    } else {
      returnJourney = "multi";
      outwardJourneyType = "multi";
    }
  }
  
  if((isRoundTrip===true)){
    result = "mono";
  }else{
    if (outwardJourneyType === "multi" || returnJourney === "multi") {
      result = "multi";
    } 
    else {
      result = "mono";
    }
  }
 
  

  setTypeCit(result)
   return result

  };


  return (
    <>
    {pageType==="mono" ? <ResumeRouteMono/> :<ResumeRouteMulti/>}

    </>
  );
};
export const extractNumbers = (str: string) => {
  var c = "0123456789";

  function check(x: any) {
    return c.includes(x) ? true : false;
  }
  if (str) {
    return Array.from(str).reduce((x, y) => (check(y) ? x + y : x), "");
  }
};


function validarArrayRenfe(array:any) {
    // Set de los proveedores esperados
    const proveedoresEsperados = new Set(["renfe-ave", "renfe-cercanias"]);

    // Set para almacenar los proveedores únicos encontrados
    const proveedoresEncontrados = new Set() as any;

    // Recorremos el array para llenar el set de proveedores encontrados
    for (const objeto of array) {
        proveedoresEncontrados.add(objeto.provider);
    }

    // Comparamos ambos sets
    return proveedoresEncontrados.size === proveedoresEsperados.size &&
           [...proveedoresEncontrados].every(proveedor => proveedoresEsperados.has(proveedor));
}
